module.exports = __webpack_public_path__ + "img/tongli.ffd8f63b.jpg";